export default {
  position: 'relative',
  transition: '0.3s',
  height: 37,
  display: 'flex',
  alignItems: 'center',
  '&:hover': {
    backgroundColor: '#e7e7e7'
  }
}



// WEBPACK FOOTER //
// ./src/styles/tabs/responsive.js